/**
 * Easy Aspect Ration Computation
 */

/**
 *
 * @param {number|number[]|string} aspectRatio
 * @param {{width: number, height: number}} viewSize
 * @returns {
 * 		{width: number, paddingLeft: number, height: number}
 * 		| {width: number, height: number, paddingTop: number}
 * }
 */
export function computeAspectBoxedSize(aspectRatio, viewSize) {
	const ar = computeAspectRatio(aspectRatio);

	const boxedV = computeAspectHeight(ar, viewSize.width, viewSize.height);
	const boxedH = computeAspectWidth(ar, viewSize.height, viewSize.width);

	if (boxedV.height <= viewSize.height) {
		return boxedV;
	}

	return boxedH;
}



/**
 *
 * @example
 * computeAspectRatio(1.7) // 1.7  // returned as is
 *
 * @example
 * computeAspectRatio([2560, 1440]) // 1.77777
 *
 * @example
 * computeAspectRatio('16:9') // 1.77777
 *
 * @param {number|number[]|string} aspectRatio
 *
 * @returns {number}
 */
export function computeAspectRatio(aspectRatio) {
	const compute = (a, i) => a
		? a / i
		: i;

	if (typeof aspectRatio === 'number') {
		return aspectRatio;
	}

	if (Array.isArray(aspectRatio)) {
		return aspectRatio.reduce(compute, null);
	}

	return `${aspectRatio}`
		.split(':')
		.map(parseFloat)
		.reduce(compute, null);
}



/**
 *
 * @param {number|number[]|string} aspectRatio
 * @param {number} width
 * @param {number} containerHeight
 * @returns {{ width: number, height: number, paddingTop: number }}
 */
export function computeAspectHeight(aspectRatio, width, containerHeight= 0) {
	const height = (width / aspectRatio);

	const paddingTop = Math.abs((containerHeight - height) / 2);

	return {
		width,
		height,
		paddingTop,
	};
}



/**
 *
 * @param {number|number[]|string} aspectRatio
 * @param {number} height
 * @param {number} containerWidth
 * @returns {{width: number, paddingLeft: number, height: *}}
 */
export function computeAspectWidth(aspectRatio, height, containerWidth) {
	const width = (height * aspectRatio);

	const paddingLeft = Math.abs((width - containerWidth) / 2);

	return {
		width,
		height,
		paddingLeft,
	};
}


